import { render, staticRenderFns } from "./ModalRegistro.vue?vue&type=template&id=6be66968&"
import script from "./ModalRegistro.vue?vue&type=script&lang=js&"
export * from "./ModalRegistro.vue?vue&type=script&lang=js&"
import style0 from "./ModalRegistro.vue?vue&type=style&index=0&id=6be66968&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports